<template>
    <div>
        <PasoUno
            :pack="pack"
            @zonaSeleccionada="zona_seleccionada = $event"
            v-if="! zona_seleccionada"
        />

        <PasoDos
            v-if="zona_seleccionada"
            :zona="zona_seleccionada"
            :disabled="asientos.length > 0"
            :pack="pack"
            @reset="reset"
            @continuar="pasoDosTerminado"
        />

        <PasoTres
            v-if="asientos.length > 0"
            :pack="pack"
            :asientos="asientos"
            :session_id="session_id"
            @continuar="pasoTresTerminado"
        />

        <PasoCuatro
            v-if="formulario_compra"
            :asientos="asientos"
            :datos_comprador="datos_comprador"
            :formulario="formulario_compra"
            :session_id="session_id"
        />
    </div>
    
</template>

<script>
import PasoUno from './pasos/PasoUno.vue';
import PasoDos from './pasos/PasoDos.vue';
import PasoTres from './pasos/PasoTres.vue';
import PasoCuatro from './pasos/PasoCuatro.vue';

export default {
    props:{
        pack: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            zona_seleccionada: null,
            session_id: null,
            asientos: [],
            formulario_compra: null,
            datos_comprador: null
        }
    },
    methods: {
        reset() {
            this.zona_seleccionada = null;
            this.datos_compra = null;
        },
        pasoDosTerminado(asientos, session_id) {
            this.session_id = session_id;
            this.asientos = asientos;
        },
        pasoTresTerminado(datos, formulario) {
            this.formulario_compra = formulario;
            this.datos_comprador = datos;
        }
    },
    components: {
        PasoUno, PasoDos, PasoTres, PasoCuatro
    }
}
</script>